import { h } from 'preact';
import styles from './BirdsnestFilterTags.module.scss';
export function BirdsnestFilterTags({ activeFilters, filterMetadataCache, onRemoveFilter, onClearAll }) {
    const activeTags = [];
    Object.entries(activeFilters).forEach(([filterId, values]) => {
        const metadata = filterMetadataCache.get(filterId);
        const filterLabel = (metadata === null || metadata === void 0 ? void 0 : metadata.label) || filterId;
        values.forEach(value => {
            if (value.includes('-') && /^\d+-\d+$/.test(value)) {
                const [min, max] = value.split('-');
                const unit = (metadata === null || metadata === void 0 ? void 0 : metadata.unit) || '$';
                activeTags.push({
                    filterId,
                    filterLabel,
                    optionId: value,
                    optionLabel: `${unit}${min} - ${unit}${max}`
                });
            }
            else {
                const optionLabel = (metadata === null || metadata === void 0 ? void 0 : metadata.options.get(value)) || value;
                activeTags.push({
                    filterId,
                    filterLabel,
                    optionId: value,
                    optionLabel
                });
            }
        });
    });
    if (activeTags.length === 0) {
        return null;
    }
    return (h("div", { class: styles.filterTags },
        h("div", { class: styles.tagsContainer },
            activeTags.map((tag, index) => (h("button", { key: `${tag.filterId}-${tag.optionId}-${index}`, class: styles.tag, onClick: () => onRemoveFilter(tag.filterId, tag.optionId), type: "button" },
                h("span", { class: styles.tagText }, tag.optionLabel),
                h("svg", { class: styles.tagClose, viewBox: "0 0 12 12", fill: "none" },
                    h("path", { d: "M3 3l6 6M9 3l-6 6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }))))),
            activeTags.length > 0 && (h("button", { class: styles.clearAll, onClick: onClearAll, type: "button" }, "CLEAR ALL")))));
}
